import {
  VARIANTS_KEY,
  VARIANTS_PATH
} from 'modules/variant/redux/state'
import getReduxSelector from 'modules/redux/selectors/get'

/**
 * @return {boolean}
 */
const isSampleVariantSelect = state => {
  const path = VARIANTS_PATH[VARIANTS_KEY.IS_SAMPLE]
  return getReduxSelector(path)(state)
}

export default isSampleVariantSelect
